import { HubConnectionState } from '@microsoft/signalr'

import Vue from 'vue'
import Vuex, { StoreOptions } from 'vuex'

import actions from './actions'
import getters from './getters'
import mutations from './mutations'
import { RootState } from './state'

import auth from './auth'
import menu from './menu'
import ordering from './ordering'
import paymentMethods from './paymentMethods'
import qrCodes from './qrCodes'

Vue.use(Vuex)

const state = {
  deliverySettings: null,
  shopSettings: null,
  businessUnit: null,
  modalCount: 0,
  profile: null,
  showNewVersionNotification: false,
  version: process.env.VUE_APP_VERSION,
  webSocketStatus: HubConnectionState.Disconnected
} as RootState

const store: StoreOptions<RootState> = {
  strict: process.env.NODE_ENV !== 'production',
  state,
  actions,
  getters,
  mutations,
  modules: {
    auth,
    menu,
    ordering,
    paymentMethods,
    qrCodes
  }
}

export default new Vuex.Store<RootState>(store)
